import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import LandingPage from './pages/LandingPage';
import Dashboard from './pages/Dashboard';
import apiService from './services/api';
import HistoryPage from './pages/HistoryPage';
import SubscriptionSuccess from './pages/SubscriptionSuccess';

function App() {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    checkSession();
  }, []);

  const checkSession = async () => {
    try {
      const response = await apiService.auth.getSession();
      if (response.authenticated && response.user) {
        setUser(response.user);
      }
    } catch (error) {
      console.error('Session check failed:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleUserUpdate = (userData) => {
    setUser(userData);
  };

  const handleLogout = () => {
    setUser(null);
  };

  if (loading) {
    return (
      <div className="min-h-screen bg-dark-950 flex items-center justify-center">
        <div className="text-center">
          <div className="w-12 h-12 border-4 border-primary-500 border-t-transparent rounded-full animate-spin mx-auto mb-4"></div>
          <p className="text-dark-400">Loading...</p>
        </div>
      </div>
    );
  }

  return (
    <Router>
      <Routes>
        <Route 
          path="/" 
          element={<LandingPage user={user} onUserUpdate={handleUserUpdate} onLogout={handleLogout} />} 
        />
        <Route 
          path="/dashboard" 
          element={<Dashboard user={user} onLogout={handleLogout} />} 
        />

        <Route path="/history" element={<HistoryPage />} />
        <Route path="/subscription-success" element={<SubscriptionSuccess />} />
      </Routes>
    </Router>
  );
}

export default App;